import classNames from 'classnames'
import React, { useCallback, useState } from 'react'
import { Dropdown } from '../../Forms/Dropdown'

export interface CountrySelectorProps {
  additionalClassName?: string
  countries: string[]
  label: string
  onSelectCountry: (country: string) => void
  placeholder?: string
}

export const CountrySelector = ({
  additionalClassName,
  countries,
  label,
  onSelectCountry,
  placeholder,
}: CountrySelectorProps) => {
  const [selectedCountry, setSelectedCountry] = useState<string>()

  const onChange = useCallback(
    (country: string) => {
      setSelectedCountry(country)
      onSelectCountry?.(country)
    },
    [onSelectCountry]
  )

  return (
    <div
      className={classNames('p-30 rounded-15 bg-secondary-darker', additionalClassName)}
    >
      <label className="block mb-10 text-shade-lightest-warm" htmlFor="select-country">
        {label}
      </label>

      <Dropdown
        name="select-country"
        onChange={onChange}
        options={countries.map(country => ({
          label: country,
          value: country,
        }))}
        placeholder={placeholder}
        value={selectedCountry}
        variant="button"
      />
    </div>
  )
}
